import React from "react";
import { connect } from "react-redux";
import { Steps } from "antd";

import { dadataIdle } from "../../redux/actions/daData";

import "./index.css";
import AddLicensee from "../../components/AddProfile/Forms/AddLicensee";
import AddAdministrator from "../../components/AddProfile/Forms/AddAdministrator";
import AddTariff from "../../components/AddProfile/Forms/AddTariff";
import LicenseAgreement from "../../components/AddProfile/Forms/LicenseAgreement";
import {
  getTariffTypes,
  getTariffFeePeriods,
  getTariffPrices,
  getTariffPrice
} from "../../redux/actions/Tariff";
import showConfirmWindow from "../../../../common/components/confirmPopup/confirmPopup";
import { addUserProfile } from "../../redux/actions/AddProfile";
import { interfaceActions } from "../../../../common/redux/actions/";
const { disableCaption } = interfaceActions;

class addProfileContainer extends React.Component {
  //поднять стейт полей из dadata в стейт этого компонента
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          title: "Регистрация",
          status: "finish"
        },
        {
          title: "Добавление перевозчика",
          slug: "licensee_add",
          completed: false
        },
        {
          title: "Добавление администратора",
          slug: "admin_add",
          completed: false
        },
        {
          title: "Выбор тарифа",
          slug: "tariff_choose",
          completed: false
        }
      ],
      current: 1,
      isEditable: true,
      tariffsPeriods: null,
      formData: null,
      currentForm: null
    };
    this.forms = {};
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { tariff_fee_periods, tariff_types, tariff_prices, price } = props;
    let activePeriods = [];
    const { periods } = tariff_fee_periods;
    const { types } = tariff_types;
    const { prices } = tariff_prices;
    if (periods && types && prices && !price) {
      types.map(type => {
        prices.map(price => {
          if (
            price.tariffTypeId === type.tariffTypeId &&
            price.tariffFeePeriodId === periods[0].tariffFeePeriodId
          ) {
            activePeriods.push({
              [type.tariffTypeId.toString()]: {
                tariffFeePeriod: periods[0].tariffFeePeriod,
                tariffFeePeriodId: periods[0].tariffFeePeriodId,
                tariffPrice: price.tariffPrice,
                tariffPriceId: price.tariffPriceId
              }
            });
          }
          return null;
        });
        return null;
      });
      return {
        tariffsPeriods: activePeriods
      };
    }
    return null;
  }

  componentDidMount() {
    this.props.getTariffTypes();
    this.props.getTariffFeePeriods();
    this.props.getTariffPrices();
    this.props.disableCaption(false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.price !== this.props.price) {
      const { tariffsPeriods } = this.state;
      const newPrice = this.props.price[0];
      tariffsPeriods.map(period => {
        Object.keys(period).map(key => {
          if (parseInt(key) === newPrice.tariffTypeId) {
            const per = period[key];
            Object.keys(per).map(key => {
              if (newPrice[key]) {
                per[key] = newPrice[key];
              }
              return null;
            });
          }
          return null;
        });
        return null;
      });
      this.setState({ tariffsPeriods: tariffsPeriods });
    }
  }

  next() {
    const current = this.state.current + 1;
    this.setState({ current });
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  handleFeePeriod = val => {
    this.props.getTariffPrice(val);
  };

  handleMediumFormSubmit = name => {
    const form = this.getForm(name);
    if (form) {
      form.validateFields((err, values) => {
        if (err) {
          return false;
        }
        let { formData } = this.state;
        formData = {
          ...formData,
          [name]: values
        };
        this.setState(
          () => ({
            formData,
            currentForm: null
          }),
          () => {
            this.next();
          }
        );
      });
    }
  };

  checkSubj(val) {
    if (val === "ИП") {
      return "individ";
    } else {
      return "legal";
    }
  }

  handleFieldsChange = values => {
    let obj = this.state.currentForm
      ? { ...this.state.currentForm }
      : this.state.formData && this.state.formData.AddLicensee
      ? { ...this.state.formData.AddLicensee }
      : {};
    obj["dadataSearch"] = values.key;
    obj["nameLegal"] = values.name;
    obj["addressLegal"] = values.address;
    obj["inn"] = values.inn;
    obj["kpp"] = values.kpp;
    obj["ogrn"] = values.ogrn;
    obj["subjectKey"] = this.checkSubj(values.opfShort);
    this.setState({
      currentForm: obj
    });
  };

  handleTariff = val => {
    let { formData } = this.state;
    formData = {
      ...formData,
      addTariff: val
    };
    this.setState(() => ({
      formData
    }));
  };

  handleFormSubmit = () => {
    showConfirmWindow({
      ...{
        title: "Внимание",
        content: "Вы действительно хотите принять соглашение",
        okText: "Принять",
        cancelText: "Отмена",
        className: "confirm-red",
        okType: "primary",
        width: 432,
        cancelButtonProps: {
          type: "primary",
          ghost: true
        }
      },
      onOk: () => {
        const { addUserProfile } = this.props;
        addUserProfile(this.state.formData);
      }
    });
  };

  render() {
    const {
      steps,
      current,
      isEditable,
      formProgress,
      tariffsPeriods
    } = this.state;
    const { tariffs, tariff_prices, user, defaultPrices } = this.props; // dadataSelected,
    const stepSlug = steps[current] && steps[current].slug;
    return (
      <div className="profile-add">
        <div className="profile-add__header">
          <div className="Container">
            <Steps current={current} className="profile-add__header-steps">
              {steps.map((step, idx) => {
                return step.slug !== "tariff_choose" ? (
                  <Steps.Step
                    key={idx}
                    title={step.title}
                    status={step.status ? step.status : null}
                  />
                ) : null;
              })}
            </Steps>
            <div className="profile-add__header-title">
              {steps[current]
                ? steps[current].title
                : current === 4
                ? "Лицензионное соглашение"
                : null}
            </div>
          </div>
        </div>
        <div className="profile-add__content">
          <div className="Container">
            {stepSlug === "licensee_add" && (
              <AddLicensee
                {...this.props}
                name="AddLicensee"
                setForm={this.setForm}
                isEditable={isEditable}
                data={{
                  userId: user.id,
                  photo: user.info && user.info.photo ? user.info.photo : null,
                  ...(this.state.currentForm
                    ? this.state.currentForm
                    : this.state.formData && this.state.formData.AddLicensee
                    ? this.state.formData.AddLicensee
                    : {})
                }}
                progress={formProgress}
                next={this.next}
                handleMediumFormSubmit={this.handleMediumFormSubmit}
                handleFieldsChange={this.handleFieldsChange}
              />
            )}
            {stepSlug === "admin_add" && (
              <AddAdministrator
                {...this.props}
                name="AddAdministrator"
                data={{
                  userId: user.id,
                  photo: user.info && user.info.photo ? user.info.photo : null,
                  ...(this.state.formData.AddAdministrator
                    ? this.state.formData.AddAdministrator
                    : this.props.user.info
                    ? this.props.user.info
                    : {})
                }}
                setForm={this.setForm}
                progress={formProgress}
                next={this.next}
                prev={this.prev}
                handleMediumFormSubmit={this.handleMediumFormSubmit}
                handleFieldsChange={this.handleFieldsChange}
              />
            )}
            {stepSlug === "tariff_choose" && (
              <AddTariff
                prev={this.prev}
                next={this.next}
                tariffs={tariffs}
                tariff_prices={tariff_prices}
                tariffsPeriods={tariffsPeriods}
                handleFeePeriod={this.handleFeePeriod}
                handleTariff={this.handleTariff}
                defaultPrices={defaultPrices}
              />
            )}
            {current === 4 && (
              <LicenseAgreement
                prev={this.prev}
                handleFormSubmit={this.handleFormSubmit}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function formatTariff(state) {
  const { tariff } = state.Authorization;
  const { tariff_fee_periods, tariff_types } = tariff;
  return (
    tariff_types.types &&
    tariff_types.types.map(type => {
      return {
        tariffTypeId: type.tariffTypeId,
        tariffTypeKey: type.tariffTypeKey,
        tariffType: type.tariffType,
        maxPerformerNum: type.maxPerformerNum, // исполнитель
        maxVehicleNum: type.maxVehicleNum,
        maxDriverNum: type.maxDriverNum,
        maxWorkplaceNum: type.maxWorkplaceNum,
        acbpdpGibddSend: type.acbpdpGibddSend,
        fee_periods: tariff_fee_periods.periods
      };
    })
  );
}

function formatPrices(prices) {
  if (prices) {
    let defaultPrices = [];
    prices.forEach(price => {
      if (
        defaultPrices.find(s => s["tariffTypeId"] === price["tariffTypeId"])
      ) {
        if (defaultPrices["tariffPrice"] < price["tariffPrice"]) {
          defaultPrices["tariffPrice"] = price["tariffPrice"];
        }
      } else {
        defaultPrices.push({
          tariffTypeId: price["tariffTypeId"],
          tariffPrice: price["tariffPrice"]
        });
      }
    });
    return defaultPrices;
  }
}

export default connect(
  state => ({
    // dadataSelected: selectDadataSelected(state),
    tariffs: formatTariff(state),
    defaultPrices: formatPrices(
      state.Authorization.tariff.tariff_prices.prices
    ),
    tariff_types: state.Authorization.tariff.tariff_types,
    tariff_prices: state.Authorization.tariff.tariff_prices,
    tariff_fee_periods: state.Authorization.tariff.tariff_fee_periods,
    price: state.Authorization.tariff.tariff_prices.price,
    user: state.Authorization.user
  }),
  {
    dadataIdle,
    getTariffTypes,
    getTariffFeePeriods,
    getTariffPrices,
    getTariffPrice,
    addUserProfile,
    disableCaption
  }
)(addProfileContainer);
